import Vue from 'vue';
import vf from 'vue-forage';

Vue.use(vf);

$vf.config({
  name: 'bod_storage'
})

const storage = {
  general_data_expiration_minutes: 60,
	state: {
		general_data_last_modified: 0
	},

  get_current_general_last_modified: function() {
    return this.state.general_data_last_modified;
  },

  retrieve_general_last_modified: function() {
    let vm = this;

    vm.get_item('general_data_last_modified')
      .then(function(vf_response) {
        // console.log('vf_response: ', vf_response);
        if(vf_response) {
          // SAVE TO LOCAL STATE
          Vue.set(vm.state, 'general_data_last_modified', vf_response.general_data_last_modified);
        }
        else {
          // UPDATE IN STORAGE
          vm.update_general_last_modified();
        }
      })
  },

  update_general_last_modified: function() {
    let vm = this;
    let now = new Date();

    vm.set_item('general_data_last_modified', now.getTime())
      .then(function() {
        Vue.set(vm.state, 'general_data_last_modified', now.getTime());
      })
    
  },

  get_item: function(item_key) {
    return $vf.getItem(item_key);
  },

  set_item: function(item_key, item_value) {
    // CHECK IF ITEM_VALUE IS AN OBJECT
    if(typeof item_value == 'object') {
      // APPEND "LAST_MODIFIED" TIMESTAMP
      var modified = new Date();
      modified = modified.getTime();
      item_value.last_modified = modified;
    }

    return $vf.setItem(item_key, item_value);
  },

  remove_item: function(item_key) {
    return $vf.removeItem(item_key);
  }

}

export default storage


// WEBPACK FOOTER //
// ./src/store/modules/mod_storage.js